import routes from './routes'
import { Fetch } from '../fetch'

/**
 * This services are for make the requests related to the Preferred Lanes functionality
 */
class PreferredLanesService {
  fetchPreferredLanes () {
    return Fetch('get', routes.PREFERRED_LANES + routes.READ_PREFERRED_LANES)
  }

  addPreferredLane (lane) {
    return Fetch(
      'post',
      routes.PREFERRED_LANES + routes.ADD_PREFERRED_LANE,
      getLanePayload(lane)
    )
  }

  updatePreferredLane (lane) {
    return Fetch(
      'put',
      routes.PREFERRED_LANES + routes.UPDATE_PREFERRED_LANE,
      getLanePayload(lane)
    )
  }

  deletePreferredLane (laneId) {
    return Fetch(
      'delete',
      routes.PREFERRED_LANES + routes.DELETE_PREFERRED_LANE(laneId)
    )
  }
}

const getLanePayload = (lane) => {
  return {
    lane_id: lane.lane_id || undefined,
    originState: lane.origin.state_id,
    originCity: lane.origin.city || undefined,
    destState: lane.destination.state_id,
    destCity: lane.destination.city || undefined,
    stopsCount: lane.stopsCount || undefined,
    maxWeight: lane.maxWeight || undefined,
    equipmentType: lane.equipmentType?.equipment_code || undefined
  }
}

export default new PreferredLanesService()
